function HomeErrorBanner({ loadError }) {
  if (!loadError) {
    return null;
  }

  return (
    <section className="site-rail py-5">
      <div
        aria-live="assertive"
        className="rounded-2xl border border-[#9c3d2d33] bg-[rgba(255,245,242,0.95)] px-6 py-4 text-[#8a2e20] shadow-soft"
        role="alert"
      >
        Klarte ikke laste innhold fra serveren: {loadError}
      </div>
    </section>
  );
}

export default HomeErrorBanner;